import { render } from "./UserAvatarUpload.vue?vue&type=template&id=7e53d8ef"
import script from "./UserAvatarUpload.vue?vue&type=script&lang=js"
export * from "./UserAvatarUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__